import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { ALL_GROUPS, GROUP_LIST } from '../filter-constants';
import { dropdownItemPropType } from '../filter-prop-types';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';
import {
    getTranslatedOptions,
    getTranslateSelectedOption
} from './dropdown-helpers';

export class GroupDropdown extends PureComponent {
    static propTypes = {
        groupDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType,
            disabled: PropTypes.bool
        }),
        className: PropTypes.string,
        setSelectedGroup: PropTypes.func,
        handleGroupChange: PropTypes.func
    };

    optionSelected = (selectedOption) => {
        const { setSelectedGroup, handleGroupChange } = this.props;
        setSelectedGroup(selectedOption);
        handleGroupChange();
    };

    render() {
        const { groupDropdownData, className } = this.props;
        const { data, selectedOption, disabled } = groupDropdownData;
        const i18n = window.i18n;

        return (
            <DropdownMenu
                className={className}
                options={getTranslatedOptions(data, ALL_GROUPS, i18n)}
                selectedOption={getTranslateSelectedOption(
                    selectedOption,
                    ALL_GROUPS,
                    i18n
                )}
                onSelectOption={this.optionSelected}
                disabled={disabled}
            />
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        groupDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            GROUP_LIST
        )(state)
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setSelectedGroup: dropdownDataActions.setSelectedGroup },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/group-dropdown.js